import utils from '..';
import { hasValidPolygon } from '../../containers/sites/siteSteps/locationGeometry';

const dataSources = {
  AUDIENCE_M: { id: 'AUDIENCE_M', label: 'Audience Measurement', infoText: 'Count People. Camera required' },
  TRAFFIC_M: { id: 'TRAFFIC_M', label: 'Traffic Measurement', infoText: 'Count Vehicles. Camera required' },
  MOBILE_M: {
    id: 'MOBILE_M',
    label: 'Mobile Data',
    infoText: 'Data insights from mobile usage. No camera required.'
  },
  WIFI_M: {
    id: 'WIFI_M',
    label: 'WiFi Data (Coming soon)',
    infoText: 'Estimate people by wifi connection. No camera required.'
  }
};

const hasErrorsCheck = (site, step) => {
  switch (step) {
    case 'settings':
      // Site must have no errors to proceed and Prevent empty value (from before changes were made)
      return utils.hasErrorsCheck(site.errors) || !site.displayName || !site.type;
    case 'solution':
      if (site.solution) {
        if (site.solution === 'CUSTOM') {
          return site.datasources ? site.datasources.length === 0 : true;
        }
        return false;
      }
      return true;
    case 'location':
      if (!site.latitude || !site.longitude || site.address === '') {
        return true;
      }
      if (site.geometry?.type?.toLowerCase() === 'polygon' && !hasValidPolygon(site.geometry)) {
        return true;
      }
      return false;
    default:
      return false;
  }
};

const getSiteErrorsObject = (site, errorArray) => {
  const errors = {};
  errorArray.forEach(error => {
    errors[error] = hasErrorsCheck(site, error);
  });
  return errors;
};

const populateMappingsFields = integration => {
  if (!integration) return [];

  const newMappings = {};

  integration?.mappingMetadataFields?.forEach(field => {
    const fieldName = field.replaceAll(' ', '_').toLowerCase();

    newMappings[fieldName] = '';
  });

  return newMappings;
};

const getDataSources = () => {
  return dataSources;
};

const getDataSourcesIds = () => Object.keys(dataSources);

const getDatasourceForDevice = device => {
  const solution = `${device?.solution || ''}`.toUpperCase();

  if (['FACEV2', 'CROWDV3', 'AUDIENCE'].includes(solution)) return 'AUDIENCE_M';
  if (['VEHICLECROWD', 'VEHICLEDETECTIONV1', 'VEHICLERECOGNITIONV1', 'TRAFFIC'].includes(solution)) {
    return 'TRAFFIC_M';
  }

  return null;
};

const getSolutionLabel = datasources => {
  const labels = {
    AUDIENCE_M: 'Audience',
    TRAFFIC_M: 'Traffic',
    MOBILE_M: 'Mobile',
    WIFI_M: 'WiFi'
  };

  return (datasources || []).map(datasource => labels[datasource] || datasource).join(' + ');
};

const getCountryCode = addressArray => {
  const countryObject = addressArray.filter(address => address.types[0] === 'country');
  return countryObject[0].address_components[0].short_name || '';
};

export default {
  hasErrorsCheck,
  getSiteErrorsObject,
  populateMappingsFields,
  getDataSources,
  getDataSourcesIds,
  getDatasourceForDevice,
  getSolutionLabel,
  getCountryCode
};
